import React, { useState, useEffect, useMemo } from 'react';
import { extractNumber, times100 } from '@/lib/utils';
import { TotalData, HoldingsTabKeyNames } from '../../index.type';
interface HoldingsStyleProps {
  selectedMetrics: {
    holdingsStyle?: boolean;
    [key: string]: boolean | undefined;
  };
  totalData: Pick<TotalData, HoldingsTabKeyNames>;
}

const HoldingsStyle: React.FC<HoldingsStyleProps> = ({
  selectedMetrics,
  totalData
}) => {
  const [currentSelectedMetrics, setCurrentSelectedMetrics] = useState<{
    holdingsStyle?: boolean;
    [key: string]: boolean | undefined;
  }>({});

  const [style_dimension, setStyle_dimension] = useState<
    {
      label: string;
      value: string;
    }[]
  >([]);

  useEffect(() => {
    setCurrentSelectedMetrics(selectedMetrics);
  }, [selectedMetrics]);

  useEffect(() => {
    console.log(totalData, 'totalData');
    setStyle_dimension(
      (totalData.style_dimension || '').split('、').map(item => ({
        label: item.split(' ')[0],
        value: item.split(' ')[1]
      }))
    );
  }, [totalData]);

  const last_6_months_excess_return = useMemo(() => {
    const rate = times100(totalData.excess_return_last_6months);
    return {
      rate: rate.toString(),
      unit: rate.greaterThan(0) ? '+' : '-'
    };
  }, [totalData]);

  const handleCheckboxChange = (checked: boolean) => {
    setCurrentSelectedMetrics(prev => ({
      ...prev,
      holdingsStyle: checked
    }));
  };

  return (
    <div className="rounded-lg border border-[#F0F0F0] p-3">
      {/* 标题和复选框 */}
      <div className="mb-4 flex items-center gap-2">
        <input
          type="checkbox"
          checked={currentSelectedMetrics.holdingsStyle || false}
          onChange={e => handleCheckboxChange(e.target.checked)}
          className="h-4 w-4"
        />
        <span className="text-base font-semibold text-[#1F1F1F]">持仓风格</span>
      </div>

      {/* 风格分布 */}
      <div className="space-y-3">
        {/* 大盘风格行 */}
        <div className="flex gap-2">
          <div className="flex-1 rounded-md bg-[#F0F5FF] p-2 text-center">
            <div className="text-sm text-[#1F1F1F]">主要基金风格</div>
            <div className="text-sm text-[#1F1F1F]">
              大盘成长{' '}
              {extractNumber(totalData.largest_holding_style.toString())}%
            </div>
          </div>
          <div className="flex-1 rounded-md border border-[#5959EB] bg-[#F0F5FF] p-2 text-center">
            <div className="text-sm font-medium text-[#5D2BC7]">
              近半年超额收益
            </div>
            <div className="text-sm text-[#CF1322]">
              {last_6_months_excess_return.unit}
              {last_6_months_excess_return.rate}%
            </div>
          </div>
        </div>

        {/* 大盘价值行 */}
        <div className="grid grid-cols-3 gap-2">
          {style_dimension.map(item => (
            <div className="flex-1 rounded-md bg-[#F0F5FF] p-2 text-center">
              <div className="text-sm text-[#1F1F1F]">{item.label}</div>
              <div className="text-sm text-[#1F1F1F]">{item.value}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HoldingsStyle;
